/**
 * 公开范围
 */
import React from 'react';
import { Form, Radio, Tooltip } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import OpenScopeForUser from '@/components/edit-activity-plan/open-scope-for-user';
import OpenScopeForOganazation from '@/components/edit-activity-plan/open-scope-for-oganazation';

function OpenedScope(props) {
  let OpenedScopRrequire = [];
  if (props.required) {
    OpenedScopRrequire = [
      {
        required: true,
        message: '不能为空',
      },
    ];
  }
  return (
    <>
      <Form.Item
        label="公开范围"
        name="openStatus"
        labelCol={{ span: 3 }}
        wrapperCol={{ span: 8 }}
        rules={OpenedScopRrequire}
        hidden
      >
        <Radio.Group>
          <Radio value={0}>
            部分公开
            <Tooltip title="可对指定的erp和部门公开活动，开放范围内的erp将会在活动中心的活动广场看到此活动的基本信息">
              <ExclamationCircleOutlined />
            </Tooltip>
          </Radio>
          <Radio value={1}>全部公开</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item hidden noStyle shouldUpdate>
        {({ getFieldValue }) => {
          return getFieldValue('openStatus') === 0 ? (
            <Form.Item name="activityPlanOpenUsers" noStyle>
              <OpenScopeForUser />
            </Form.Item>
          ) : null;
        }}
      </Form.Item>
      <Form.Item hidden noStyle shouldUpdate>
        {({ getFieldValue }) => {
          return getFieldValue('openStatus') === 0 ? (
            <Form.Item name="activityPlanOpenOrganizations" noStyle>
              <OpenScopeForOganazation />
            </Form.Item>
          ) : null;
        }}
      </Form.Item>
    </>
  );
}

export default OpenedScope;
